import React from "react";
import { Div, Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { RequirementItem, Icon } from "./styles";
import checkCircle from "../../../assets/icons/check-circle.svg";

const PasswordRequirements = ({ password, onValidationChange }) => {
  const requirements = [
    {
      text: "At least 12 characters long",
      fulfilled: password.length >= 12,
      key: "length"
    },
    {
      text: "One lowercase letter",
      fulfilled: /[a-z]/.test(password),
      key: "lowercase"
    },
    {
      text: "One uppercase letter", 
      fulfilled: /[A-Z]/.test(password),
      key: "uppercase"
    },
    {
      text: "One number",
      fulfilled: /\d/.test(password),
      key: "number"
    },
    {
      text: "One special character (#?!@$%^&*-)",
      fulfilled: /[#?!@$%^&*-]/.test(password),
      key: "special"
    }
  ];

  const allRequirementsMet = requirements.every(req => req.fulfilled);
  
  const unmetRequirements = requirements.filter(req => !req.fulfilled);
  
  React.useEffect(() => {
    if (onValidationChange) {
      onValidationChange(allRequirementsMet, unmetRequirements);
    }
  }, [allRequirementsMet, password, onValidationChange]);

  return (
    <Div direction="column" width="100%">
      {requirements.map((requirement, index) => (
        <RequirementItem key={index}>
          {requirement.fulfilled ? (
            <img src={checkCircle} alt="check"/>
          ) : (
            <Icon fulfilled={requirement.fulfilled} />
          )}
          <Text
            size={theme.fonts.size.xs}
            color={requirement.fulfilled ? theme.colors.dark2 : theme.colors.grey}
            weight={theme.fonts.weight.regular}
          >
            {requirement.text}
          </Text>
        </RequirementItem>
      ))}
    </Div>
  );
};

export default PasswordRequirements;
